<template>
    <div>
        <el-card class="card-login" shadow="always" :body-style="{ padding: '20px' }">
            <h2 class="pt-sans-bold">
                RECUPERAR CONTRASEÑA <br>
                <small>Espacio de formación personal</small>
            </h2>
            <div>
                <br>
                <p style="text-align: left; background: #f1f1f1; padding: 10px">
                    <strong>Recuperar contraseña:</strong> Ingrese su número de cuil para recibir en su E-mail un enlace
                    para recuperar la contraseña
                </p>

                <el-form :model="form" ref="form" :label-position="'top'" class="login" label-width="80px"
                    :inline="false" size="normal">

                    <el-form-item label="Cuil (sin guiones)" prop="cuil" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input v-mask="'############'" :disabled="!active ? false :true" v-model="form.cuil"
                            @keypress.native.enter="validarCuit"></el-input>
                    </el-form-item>
                    <p v-if="active == 2" style="padding:10px; text-align:left; color:red ">

                        Si no recuerda el la casilla de correo o ya no tiene acceso a la misma complete los siguientes
                        datos y nos comunicaremos con usted para realizar el cambio
                    </p>
                    <el-form-item v-if="active == 2" label="Correo viejo" prop="correo_viejo" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                        <el-input v-model="form.correo_viejo"></el-input>
                    </el-form-item>
                    <el-form-item v-if="active == 2" label="Correo nuevo" prop="correo_nuevo" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
            {
                type: 'email',
                message: 'correo invalido',
                trigger: ['blur', 'change'],
            },
        ]">
                        <el-input v-model="form.correo_nuevo"></el-input>
                    </el-form-item>

                    <el-button v-if="active == 2" type="warning" :loading="cargando" class="btn-100" size="default"
                        @click="enviarPass('acceso')">Crear reclamo</el-button>

                    <el-form-item v-if="!active">
                        <br>
                        <el-button type="defaul1" @click="cancelar">Cancelar</el-button>
                        <el-button type="azul" :loading="cargando" @click="validarCuit" style="float:right"
                            :disabled="form.cuil && form.cuil.length == 11 ? false : true">Continuar
                        </el-button>



                    </el-form-item>


                    <!-- <div style="background:FFFDE7; padding:10px" v-if="active">
                        Enviaremos una nueva contraseña a la siguiente casilla:<br>
                        <h4>{{ existe.email }}</h4>


                        <el-button type="primary" size="default" @click="enviarPass">Enviar contraseña</el-button>

                    </div> -->




                </el-form>
                <div style="background:FFFDE7; padding:10px" v-if="active == 1">
                    Enviaremos una nueva contraseña a la siguiente casilla:<br>
                    <h4>{{ existe.email }}</h4>


                    <el-button type="primary" class="btn-100" :loading="cargando" size="default"
                        @click="enviarPass('nuevo')">Enviar
                        contraseña</el-button>
                    <el-button type="warning" class="btn-100" size="default" @click="active = 2">No tengo acceso a esa
                        casilla</el-button>
                    <el-button type="defaul1" class="btn-100" @click="cancelar">Cancelar</el-button>
                </div>

            </div>



        </el-card>
    </div>
</template>

<script>
import { HTTP } from "@/axios"
import { EventBus } from '@/event-bus'
    export default {
        data() {
            return {
                form: {},
                existe:{},
                active:0,
                cargando:false,

            }
        },
        methods: {
            enviarPass(accion)
            {
                this.form.accion = accion
                this.form.docente_id = this.existe.id
                this.cargando = true;
               setTimeout(() => {
                  
                   HTTP.post('/docente/enviarPass', this.form)
                       .then(res => {
                           this.cargando = false;
                           if (res.data) {
                              const content = accion === 'acceso' ? 'Generamos un reclamo y recibirá un mensaje a su casilla para validar su identidad' : 'En unos minutos recibirá un correo electrónico con un link para generar una nueva contraseña'
                               this.$alert(content, 'Recuperar Contraseña', {
                                confirmButtonText: 'Aceptar',
                                type:'success',
                                callback: () => {
                                    this.cancelar()
                                }
                              })
                              
                           }
                           else {
                            //    this.active = 0;
                               this.$alert('En el transcurso de la jornada recibirá un correo eléctronico con un link para generar una nueva contraseña, revise SPAM y No vuelva a Recuperar Contraseña', 'Recuperar Contraseña', {
                                   confirmButtonText: 'Aceptar',
                                   type: 'warning',
                                   callback: () => {
                                       this.cancelar()
                                   }
                               })
                           }

                       })
                       .catch(() => {
                           this.cargando = false;
                           this.active = 0;
                           this.$alert('No pudimos completar el proceso de recuperación, refresque la página y reintente', { type: 'error' })


                       })
               }, 100);
            },
            validarCuit(event) {
                event.preventDefault();

                this.cargando = true;
                HTTP.post('/docente/validarCuil', { cuil: this.form.cuil })
                    .then(res => {
                        this.cargando = false;
                        if (res.data) {

                            this.existe = res.data
                            this.active = 1;
                        }
                        else {
                            this.active = 0;
                            this.$confirm('CUIT inexistente, deberá crear un nuevo usuario', 'CUIT NO ENCONTRADO', {
                                confirmButtonText: 'Crear nuevo usuario',
                                cancelButtonText: 'Regresar',
                                type: 'error'
                            }).then(() => {
                                EventBus.$emit('CancelarRe', 'registro')
                            }).catch(() => {
                           
                            });
                        }

                    })
                    .catch((e) => {
                        this.cargando = false;
                        this.$alert('No se pudo validar el CUIL, refresque la página y reintente','ERROR', { type: 'error' })


                    })
            },
            cancelar() {
                EventBus.$emit('CancelarRe', 'login')
            }
        },
    }
</script>

<style lang="scss" scoped>
 .card-login {
     margin-top: 80px;
     min-height: 610px;
 }

.card-login h2 {
    text-align: center;
    text-transform: uppercase;
    // margin: 0;
    font-size: 20px;
    line-height: 1.1;
}

 .card-login p {
     text-align: center;
     font-size: 14px;
 }

  .login {
      width: 250px;
      margin: 20px auto;
  }

  .login-msj {
      font-size: 14px;
      padding: 10px;
      border: 1px solid #ef9a9a75;
      background: #ffebee70;
      border-radius: 4px;
  }
   @media screen and (max-width:768px) {
       .card-login {
        padding-top: 20px;
           margin-top: 0px;
           min-height: calc(100vh - 110px);
           //   overflow-y: scroll;
       }
   }
</style>